import React, { Component } from 'react'
import { NavLink, withRouter } from "react-router-dom"
import API from "../../Services/Api";
import AuthAction from '../../Redux/AuthRedux'
import { connect } from 'react-redux'
import * as R from 'ramda'
import EmployeeAction from '../../Redux/EmployeeRedux'

var opButton = 'btn btn-circle btn-grey active'
var clButton = 'btn btn-circle btn-grey'
var clContentPopup = 'app-menu-popup app-menu-popup-hide'

var connected = false;
var socket;

const eksadbusUrl = "";
// const eksadbusUrl = process.env.REACT_APP_HCIS_MESSAGING_EKSAD;

class Pages extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      notifClass: clContentPopup,
      smallNotifClass: clButton,
      auth: props.auth,
      dataEmployee: '',

      type: '',
      eventClose: true,
    }
  }

  intervalID;

  getCountPage() {
    this.reloadService();
  }

  componentDidMount() {
    // this.getNotifBell();
    // console.log("--------GETNOTIFBELL------------");
  }

  componentWillReceiveProps(newProps) {
    console.log("--------GETNOTIFBELL3------------");
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(jwtToken)) {
      // clearInterval(this.intervalID);
      return;
    }
    let { auth } = newProps
    this.setState({ auth })
    if (!R.isNil(auth.user)) {
      // this.reloadService();
      let userId = auth.user.idUser;
      // this.openMessage(userId);
      // this.intervalID = setInterval(this.getCountPage.bind(this), 5000);
    }
  }

  componentWillMount() {
    // console.log("--------GETNOTIFBELL2------------");
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(jwtToken)) {
      // clearInterval(this.intervalID);
      return;
    }
    let { auth } = this.state
    if (!R.isNil(auth.user)) {
      // this.reloadService();
      // console.log(auth.user);
      let userId = auth.user.idUser;
      // this.openMessage(userId);
      // this.intervalID = setInterval(this.getCountPage.bind(this), 5000);
    }
  }

  updateNotifBell = (msg) => {
    console.log("-----NOTIF INCOMING----------");
    console.log(msg);
    this.setState({
      data: JSON.parse(msg.data)
    })
  }

  openMessage = (userId) => {
    socket = new WebSocket(eksadbusUrl + userId);
    socket.onopen = function () {
      connected = true;
      console.log("Connected to channel eksadbus");
      socket.send("_ready_");
    };
    socket.onmessage = this.updateNotifBell;
  }

  reloadService = () => {
    setTimeout(() => {
      this.getNotifBell()
    }, 200);
  }

  getNotifBell = async () => {
    let res = await API.create('NOTIF_BELL').postGetNotifBell({})
    if (res.ok) {
      if (res.data.data && res.data.data !== null) {
        this.setState({
          data: res.data.data
        })
      } else {
        this.setState({
          data: {}
        })
      }
    } else {
      this.setState({
        data: {}
      })
    }
  }

  saveNotifUserSeen(type) {
    let payload = {
      type: type
    }

    let res = API.create('NOTIF_BELL').postNotifUserSeenSave(payload)
    if (res.ok) {
      this.getNotifBell()
    }
  }

  handleClickOutside(element) {
    const outsideclickListener = event => {
      if (!element.contains(event.target)) {
        element.style.display = 'none'
        removeClickListener()
      }
    }

    const removeClickListener = () => {
      this.setState({ smallNotifClass: clButton, eventClose: true })
      document.removeEventListener('click', outsideclickListener)
    }

    document.addEventListener('click', outsideclickListener)
  }

  opNotif = () => {
    var element = document.getElementById('app-notif')
    element.style.display = 'block'
    this.setState({ smallNotifClass: opButton, eventClose: !this.state.eventClose })
    if (this.state.eventClose) {
      this.handleClickOutside(element)
    }

    // if (this.state.notifClass === clContentPopup) {
    //   this.setState({notifClass: opContentPopup})
    //   this.setState({smallNotifClass: opButton})
    // } else {
    //   this.setState({notifClass: clContentPopup})
    //   this.setState({smallNotifClass: clButton})
    // }
  }

  onClickApproval = () => {
    var element = document.getElementById('app-notif')
    element.style.display = 'none'
    this.setState({
      smallNotifClass: opButton,
      type: "APPROVAL"
    }, () => {
      this.saveNotifUserSeen(this.state.type)
    })
    this.handleClickOutside(element)
  }

  // renderRedirect(path) {
  //   this.props.history.push(path);
  // }

  contentApproval() {
    return (
      <div className="card-notif">
        <div className="c-n-col-1">
          {this.state.data && this.state.data.trxApproval ?
            <button
              type='button'
              className='btn btn-circle'
              style={{ height: "100%", width: "45%", backgroundColor: "red", color: "white", justifyContent: 'center' }}
            // onClick={this.onClickApproval}
            >
              {this.state.data.trxApproval}
            </button> :
            <button
              type='button'
              className='btn btn-circle'
              style={{ height: "100%", width: "45%", justifyContent: 'center', }}
            // onClick={() => {
            //   this.onClickApproval()
            //   // this.renderRedirect("/tasklist")
            // }}
            >
              {"0"}
            </button>
          }
        </div>
        <div className="c-n-col-2">
          <div className="txt-site txt-11">
            <div className="txt-site txt-bold txt-main">
              <NavLink type='button' to="/tasklist" onClick={this.onClickApproval}>
                Approval
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    )
  }

  contentActivity() {
    return (
      <div className="card-notif">
        <div className="c-n-col-1">
          {this.state.data && this.state.data.trxActivity ?
            <button
              type='button'
              className='btn btn-circle'
              style={{ height: "100%", width: "45%", backgroundColor: "red", color: "white", justifyContent: 'center' }}
            >
              {this.state.data.trxActivity}
            </button> :
            <button
              type='button'
              className='btn btn-circle'
              style={{ height: "100%", width: "45%", justifyContent: 'center', }}
            >
              {"0"}
            </button>
          }
        </div>
        <div className="c-n-col-2">
          <div className="txt-site txt-11">
            <div className="txt-site txt-bold txt-main">
              Activity
            </div>
          </div>
        </div>
      </div>
    )
  }

  contentInfo() {
    return (
      <div className="card-notif">
        <div className="c-n-col-1">
          {this.state.data && this.state.data.trxInfo ?
            <button
              type='button'
              className='btn btn-circle'
              style={{ height: "100%", width: "45%", backgroundColor: "red", color: "white", justifyContent: 'center' }}
            >
              {this.state.data.trxInfo}
            </button> :
            <button
              type='button'
              className='btn btn-circle'
              style={{ height: "100%", width: "45%", justifyContent: 'center', }}
            >
              {"0"}
            </button>
          }
        </div>
        <div className="c-n-col-2">
          <div className="txt-site txt-11">
            <div className="txt-site txt-bold txt-main">
              Info
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <button
          onClick={this.opNotif}
          className={this.state.smallNotifClass}>
          {this.state.data && this.state.data.total ?
            <span className="btn-notif" style={{ backgroundColor: "red" }}>
              {this.state.data.total}
            </span> : null
          }
          <i className="far fa-lg fa-bell txt-site txt-15"></i>
        </button>

        <div
          id="app-notif"
          style={{ top: "45px", width: "150px" }}
          className={this.state.notifClass}>
          <div className="txt-site txt-left">

            <div className="padding-15px txt-site txt-12 txt-bold txt-main bdr-bottom">
              Notifications
            </div>

            <div className="content">
              {this.contentApproval()}
              {this.contentActivity()}
              {this.contentInfo()}
            </div>

          </div>
        </div>

      </div>
    )
  }

}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    employee: state.employee,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
    getEmployeeName: obj => dispatch(EmployeeAction.getEmployeeName(obj))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Pages);